export const parseTimestamp = (value) => {
  if (typeof value !== 'string') return 0;
  const match = value.match(/(?:(\d{2}):(\d{2}):(\d{2}),(\d{3}))/);
  if (!match) return 0;
  const [, hh, mm, ss, ms] = match;
  const hours = Number(hh) || 0;
  const minutes = Number(mm) || 0;
  const seconds = Number(ss) || 0;
  const milliseconds = Number(ms) || 0;
  return hours * 3600 + minutes * 60 + seconds + milliseconds / 1000;
};

export const parseSubtitleContent = (content) => {
  if (!content) return [];

  const blocks = content
    .split(/\r?\n\r?\n+/)
    .map((block) => block.trim())
    .filter(Boolean);

  const segments = [];

  blocks.forEach((block, index) => {
    const lines = block.split(/\r?\n/).filter(Boolean);
    if (!lines.length) return;

    const timeLineIndex = lines.findIndex((line) => line.includes('-->'));
    if (timeLineIndex === -1) return;

    const timeLine = lines[timeLineIndex];
    const textLines = lines.slice(timeLineIndex + 1);
    const [startRaw, endRaw] = timeLine.split('-->').map((part) => part.trim());
    const start = parseTimestamp(startRaw);
    const end = parseTimestamp(endRaw);
    const rawText = textLines.join('\n');

    const sentenceIdMatch = rawText.match(/\[\s*sentence_id\s*=\s*(\d+)\s*\]/i);
    const sentenceId = sentenceIdMatch ? Number(sentenceIdMatch[1]) : null;
    const cleanedText = rawText.replace(/\[\s*sentence_id\s*=\s*\d+\s*\]\s*/i, '').trim();

    segments.push({
      id: index,
      start,
      end,
      text: cleanedText,
      sentenceId,
    });
  });

  return segments.sort((a, b) => a.start - b.start);
};

export const buildSentenceTimingMap = (segments) => {
  if (!Array.isArray(segments) || segments.length === 0) {
    return {};
  }

  return segments.reduce((acc, segment, index) => {
    const key =
      segment.sentenceId !== null && segment.sentenceId !== undefined
        ? segment.sentenceId
        : segment.id ?? index;

    if (key !== null && key !== undefined) {
      acc[key] = {
        start: segment.start ?? null,
        end: segment.end ?? null,
      };
    }
    return acc;
  }, {});
};
